import React from "react";
import {
  Edit,
  SimpleForm,
  NumberInput,
  TextInput,
  SimpleFormIterator,
  ArrayInput,
  AutocompleteInput,
  ReferenceInput,
  FormDataConsumer
} from "react-admin";
import { Typography } from "@mui/material";
import { iterator_autocomplete, editTitle } from "../../../../customStyles/ra-custom-styles";
import { MONTH_VALID } from "../../../../utils/constants";
import InactiveDeleteOptionEditToolbar from "../../Partials/CustomComponents/InactiveDeleteOptionEditToolbar";

const parseSubscriptionsPrices = record => ({
  ...record,
  subscriptions_prices: record.subscriptions_prices?.map(({ prices, ...rest }) => ({
    ...rest,
    price: prices?.find(({ currency }) => currency === "EUR")?.price
  })),
});

const EditCatalog = () => {
  return (
    <Edit
      title="Издание от каталог"
      mutationMode="pessimistic"
      queryOptions={{ select: parseSubscriptionsPrices }}
    >
      <>
        <Typography sx={editTitle}>Редакция на издание</Typography>
        <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
          <NumberInput
            label="Каталожен номер"
            source="catalog_number"
            disabled
          />
          <TextInput
            label="Заглавие"
            source="title"
          />
          <TextInput
            label="Вид издание"
            source="edition_type"
          />

          <ArrayInput
            label="Абонаменти"
            source="subscriptions_prices"
          >
            <SimpleFormIterator inline>
              <FormDataConsumer>
                {({ getSource }) => <NumberInput
                  label="Цена в €"
                  source={getSource("price")}
                  margin={"dense"}
                  sx={{ width: "fit-content" }}
                />}
              </FormDataConsumer>

              <ReferenceInput
                source="month_index"
                reference={MONTH_VALID}
              >
                <AutocompleteInput
                  label="За брой месеци"
                  sx={iterator_autocomplete}
                  optionText="month_index"
                />
              </ReferenceInput>
            </SimpleFormIterator>
          </ArrayInput>
        </SimpleForm>
      </>
    </Edit>
  );
};

export default EditCatalog;
